// src/components/audition-booking-wizard/scheduler/DateStrip.jsx
import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const DateStrip = ({ uniqueDates, selectedDate, setSelectedDate, scrollRef, handleScroll }) => {
    return (
        <div className="date-navigation-wrapper d-flex align-items-center">
            <button type="button" className="scroll-arrow me-2" onClick={() => handleScroll("left")}>
                <FaChevronLeft />
            </button>
            <div
                className="date-strip-container d-flex"
                ref={scrollRef}
                style={{
                    overflowX: "auto",
                    scrollBehavior: "smooth",
                    gap: "10px",
                    whiteSpace: "nowrap",
                    flexGrow: 1, // Allow it to take available space
                    width: '100%' // Ensure it takes 100% width of its flex parent
                }}
            >
                {uniqueDates.map((date, index) => {
                    const d = new Date(date);
                    return (
                        <div
                            key={index}
                            className={`date-tile ${selectedDate === date ? "active" : ""}`}
                            onClick={() => {
                                setSelectedDate(date);
                            }}
                            style={{
                                minWidth: "110px",
                                cursor: "pointer"
                            }}
                        >
                            <span className="day-name">
                                {d.toLocaleDateString("en-US", { weekday: "short" })}
                            </span>
                            <span className="date-num">
                                {d.toLocaleDateString("en-US", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit"
                                })}
                            </span>
                        </div>
                    );
                })}
            </div>
            <button type="button" className="scroll-arrow ms-2" onClick={() => handleScroll("right")}>
                <FaChevronRight />
            </button>
        </div>
    );
};

export default DateStrip;